import React, { useMemo, useId } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import type { InputType } from "reactstrap/types/lib/Input";
import type { FormikFieldType } from "interfaces/shared.types";

type RadioInputProps = {
  field?: FormikFieldType;
  label: string | React.ReactNode;
  classNames?: string;
  htmlFor?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labelclass?: string;
  name: string;
  type: InputType;
  value: string;
  checked: boolean;
  disabled: boolean;
};

export const RadioInput = ({
  field,
  label,
  classNames,
  htmlFor,
  onChange,
  labelclass,
  ...restProps
}: RadioInputProps) => {
  const id = useId();
  const inputId = useMemo(
    () => htmlFor || `radio-${field?.name || "input"}-${id}`,
    [htmlFor, field?.name, id],
  );

  return (
    <FormGroup check className={classNames}>
      <Input
        {...field}
        {...restProps}
        id={inputId}
        onChange={onChange || field?.onChange}
      />
      <Label check htmlFor={inputId} className={labelclass}>
        {label}
      </Label>
    </FormGroup>
  );
};
